<template>
  <v-container fluid>
    <v-toolbar>
      <v-toolbar-title>
        {{ app.name | capitalize }} {{ $t('TILES.ITEM_GROUP') }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn dark color="indigo" @click="$router.go(-1)">
        {{ $t('BUTTON.BACK') }}
      </v-btn>
      <v-btn dark class="ml-2" color="primary" @click="create">
        <v-icon left>mdi-plus</v-icon>
        {{ $t('ITEM.NEW') }} {{ $t('TILES.ITEM_GROUP') }}
      </v-btn>
    </v-toolbar>

    <v-sheet class="mt-5 pa-5" tile>
      <tiles-group-list :id="id" @edit="edit" @clone="clone"></tiles-group-list>
    </v-sheet>

    <template v-if="action">
      <component
        :is="`tiles-group-${action}`"
        :id="currentTileGroupId"
        :key="currentTileGroupId"
        :application-id="id"
        @created="created"
        @cancel="cancel"
        @edited="edited"
      ></component>
    </template>

    <confirm-dialog ref="confirm"></confirm-dialog>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { capitalize } from '@/modules/_global/filters';

export default {
  name: 'TilesGroupPage',

  components: {
    TilesGroupCreate: () => import('../components/TilesGroup/TilesGroupCreate'),
    TilesGroupEdit: () => import('../components/TilesGroup/TilesGroupEdit'),
    TilesGroupList: () => import('../components/TilesGroupList'),
    ConfirmDialog: () => import('@/modules/_global/_components/ConfirmDialog')
  },

  filters: {
    capitalize
  },

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    app: {},
    action: null,
    currentTileGroupId: null
  }),

  mounted() {
    this.showApp(this.id).then(({ data }) => {
      this.app = data;
    });
  },

  methods: {
    ...mapActions('tile', ['cloneTilesGroup']),
    ...mapActions('apps', ['showApp']),
    clone(tileGroup) {
      this.$refs.confirm.open(this.$t('TILES.CLONE_QUESTION')).then(confirm => {
        if (confirm) {
          this.cloneTilesGroup({
            applicationId: this.id,
            tilesGroupId: tileGroup.id
          });
        }
      });
    },

    create() {
      this.action = 'create';
      this.currentTileGroupId = null;
    },

    created(tilesGroup) {
      this.edit(tilesGroup);
    },

    edit(tileGroup) {
      this.action = 'edit';
      this.currentTileGroupId = tileGroup.id;
    },

    edited(tilesGroup) {
      this.cancel();
    },

    cancel() {
      this.action = null;
      this.currentTileGroupId = null;
    }
  }
};
</script>
